import { Link } from "react-router-dom";
import "./dashboard.scss";

const formatDelta = (delta) => {
  if (delta === null || delta === undefined || Number.isNaN(delta)) return null;
  if (delta === 0) return { text: "Sin cambios", tone: "neutral" };
  const sign = delta > 0 ? "+" : "";
  return { text: `${sign}${delta} vs mes anterior`, tone: delta > 0 ? "up" : "down" };
};

const KpiCard = ({ title, value, delta, deltaLabel, to, Icon, tone = "blue", loading }) => {
  const d = deltaLabel ? { text: deltaLabel, tone: "neutral" } : formatDelta(delta);
  const displayValue = loading || value === null || value === undefined ? "—" : value;

  return (
    <Link to={to} className={`kpi-card kpi-${tone}`}>
      <div className="kpi-icon">
        {Icon ? <Icon size={28} /> : null}
      </div>
      <div className="kpi-body">
        <span className="kpi-title">{title}</span>
        <span className="kpi-value">{displayValue}</span>
        {d && <span className={`kpi-delta delta-${d.tone}`}>{d.text}</span>}
      </div>
    </Link>
  );
};

export default KpiCard;
